import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import formatAnnouncementDate from "@/utils/formatAnnouncementDate";
const S3_URL = import.meta.env.VITE_S3_URL;

export type CardExperienceProps =
  | {
  withCancel: true;
  item: any;
  diff: any;
  rewardText: any;
  showCancel: Record<string, boolean>;
  toggleCancel: (id: string) => void;
  handleCancel: (id: string) => void;
}
  | {
  withCancel?: false;
  item: any;
  diff: any;
  rewardText: any;
  showCancel?: never;
  toggleCancel?: never;
  handleCancel?: never;
};


const CardExperience = (props: CardExperienceProps) => {
  const {
    item,
    diff,
    rewardText,
    withCancel = false,
  } = props;

  let badgeColor = "bg-[#00C3EF]"
  if(item.dDayStatus === 'today') badgeColor = "bg-[#E100FF]"
  if(item.dDayStatus === 'closed') badgeColor = "bg-[#C7C7C7]"

  return (
    <div className="flex gap-3 mt-2 overflow-hidden transition-shadow border-b pb-2 mx-3">
      <div className="w-full flex">
        <div className="w-11/12">
          <Link to={`/detailPage/${item.campaign_id}`} className={`flex ${diff < 1 ? "" : ""}`}>
            <div className="w-24 h-24 flex-shrink-0 overflow-hidden rounded-lg">
              <img
                src={`${S3_URL}${item.thumbnail}`}
                alt={item.title}
                className="object-cover w-full h-full"
              />
            </div>
            <div className="pl-2 max-w-[calc(100%-8.5rem)] flex flex-col justify-between">
              <div>
                <h3 className="font-bold text-[13px] text-gray-800 line-clamp-1 truncate">
                  {item.title || "제목 없음"}
                </h3>
                <div className="flex text-[9px]">
                  <p className="text-[11px] pt-1 text-[#999999] line-clamp-2 w-full">
                    {rewardText || "설명 없음"}
                  </p>
                </div>
              </div>
              <div className="flex items-center text-[10px]">
                발표 날짜: {" "}
                {formatAnnouncementDate(item.announcement)}
                 <div className={`${badgeColor} ml-2 py-[3px] px-2 flex items-center text-[7px] rounded-full shadow-sm border transition-colors text-white font-medium`}>
                   {item.dDayLabel}
                 </div>
              </div>
            </div>
          </Link>
        </div>

        {withCancel && (
          <div className="w-1/12 relative flex flex-col items-end justify-start">
            <button
              className="flex items-center gap-2 text-[9px] bg-[#fe7070] rounded-full shadow-sm px-2 border transition-colors text-white font-medium"
              onClick={() => props.toggleCancel?.(item.id)}
            >
              <XCircle width={12} />
              <div className="flex justify-between px-1">
                <div>취</div>
                <div>소</div>
              </div>
            </button>
            {props.showCancel?.[item.id] && (
              <button
                onClick={() => props.handleCancel?.(item.id)}
                className="absolute top-8 right-0 bg-red-500 text-[9px] rounded-md shadow py-1 border transition-all text-white font-medium min-w-[90px] whitespace-nowrap text-center"
              >
                취소하시겠습니까?
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};


export default CardExperience;